import { type TableNameAdvancedFiltersConfigMap } from '@autone/ui-next/components';

import { type AssortmentAdvancedFiltersTranslationsMap } from '../../../../hooks';
import { type TableNamesWithAdvancedFilters } from '../../../../storage/session-storage';

import { getProductLocationsTableAdvancedFilterConfig } from './product-locations-table.config';
import { getProductsTableAdvancedFilterConfig } from './products-table.config';
import { getSkuLocationsTableAdvancedFilterConfig } from './sku-locations-table.config';

export const ASSORTMENT_ADVANCED_FILTERS_CONFIG_MAP = {
  productLocationsTable: getProductLocationsTableAdvancedFilterConfig,
  productsTable: getProductsTableAdvancedFilterConfig,
  skuLocationsTable: getSkuLocationsTableAdvancedFilterConfig,
} as const satisfies TableNameAdvancedFiltersConfigMap<
  TableNamesWithAdvancedFilters,
  AssortmentAdvancedFiltersTranslationsMap
>;
